import { Box, Paper, Typography } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { CrudFilters, useGo, useNavigation, useResourceParams } from '@refinedev/core';
import { CreateButton, DeleteButton, Show, useDataGrid } from '@refinedev/mui';

import { MODULE_CONTENT_MAP } from '@attackiq/constants';

import useCurrentResource from '../../hooks/useCurrentResource';
import { ModuleContent } from '../../types';

const ModuleShow = () => {
  const { id } = useResourceParams();
  const { data: module } = useCurrentResource();
  const { dataGridProps, search } = useDataGrid<ModuleContent>({
    resource: 'module_contents',

    onSearch: search => {
      const filters: CrudFilters = [];

      filters.push({
        field: 'search',
        value: search,
        operator: 'eq'
      });

      return filters;
    },

    filters: {
      initial: [
        {
          field: 'search',
          value: '',
          operator: 'eq'
        }
      ],

      permanent: [
        {
          field: 'module_id',
          operator: 'eq',
          value: id
        }
      ]
    }
  });
  const go = useGo();
  const { createUrl } = useNavigation();

  const columns: GridColDef<ModuleContent>[] = [
    {
      field: 'content_type',
      headerName: 'Model',
      renderCell: params => MODULE_CONTENT_MAP[params.row.content_type_model],
      flex: 1
    },
    {
      field: 'content_object__name',
      headerName: 'Name',
      renderCell: params => params.row.content_object?.name || params.row.content_object?.template_name,
      sortable: false,
      flex: 2
    },
    {
      field: 'content_object__description',
      headerName: 'Description',
      renderCell: params => params.row.content_object?.description || params.row.content_object?.template_description,
      sortable: false,
      flex: 2
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: ({ row }) => {
        const name = row.content_object?.name || row.content_object?.template_name;
        return (
          <DeleteButton
            resource="module_contents"
            recordItemId={row.id}
            confirmTitle={`Do you want to delete Module Content for ${name}?`}
            hideText
          />
        );
      },
      sortable: false,
      maxWidth: 100
    }
  ];

  const handleAddContent = () => {
    const moduleContentsCreateUrl = createUrl('module_contents');

    go({ to: `${moduleContentsCreateUrl}?module_id=${id}`, type: 'push' });
  };

  return (
    <>
      <Paper sx={{ mb: 2 }}>
        <Box sx={{ p: 2 }}>
          <Typography variant="subtitle2">Module ID: {id}</Typography>
          <Typography variant="subtitle2">Module Name: {module?.display_name}</Typography>
        </Box>
      </Paper>
      <Show
        headerButtons={({ defaultButtons }) => {
          return (
            <>
              {defaultButtons}
              <CreateButton variant="text" onClick={handleAddContent}>
                Add Content
              </CreateButton>
            </>
          );
        }}
      >
        <Typography variant="h5" sx={{ pb: 2 }}>
          Content:
        </Typography>
        <DataGridPro
          {...dataGridProps}
          filterModel={undefined}
          columns={columns}
          showToolbar
          pagination
          onFilterModelChange={({ quickFilterValues }) => {
            search(quickFilterValues?.join(' ') || '');
          }}
          disableColumnFilter
        />
      </Show>
    </>
  );
};

export default ModuleShow;
